import { render, staticRenderFns } from "./CiscoBeach.vue?vue&type=template&id=99b3ef3c&scoped=true&"
import script from "./CiscoBeach.vue?vue&type=script&lang=js&"
export * from "./CiscoBeach.vue?vue&type=script&lang=js&"
import style0 from "./CiscoBeach.vue?vue&type=style&index=0&id=99b3ef3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b3ef3c",
  null
  
)

export default component.exports